<template>
    <div>
        <template v-for="i in selectCount">
            <b-row :key="'row_' + i" class="mb-2">
                <b-col cols="10">
                    <b-form-select
                            :key="'select_' + i"
                            v-model="selectValues[i]"
                            :required="required"
                            @change="emit">
                        <template v-slot:first v-if="defaultLabel">
                            <b-form-select-option :value="null">
                                {{defaultLabel}}
                            </b-form-select-option>
                        </template>
                        <b-form-select-option v-for="(option,index) in options" :key="index"
                                              :value="option.value"
                                              :disabled="isDisabled(option.value)">
                            {{option.text}}
                        </b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col cols="1" v-if="i === selectCount && selectValues[i] != null">
                    <Icon icon="plus" size="2x" :key="'add_' + i" @click="addSelect"
                          class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
                <b-col cols="1" v-if="selectCount === i && i > 1">
                    <Icon icon="minus" size="2x" :key="'remove_' + i"
                          @click="removeSelect(i)" class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
  import {ROLES_GPEC, ROLES_SECURITE, ROLES_EMPREINTE, ROLES_EFFECTIFS} from "../constants/common";

  export default {
    name: "MultiselectCustom",
    props: ['value', 'options', 'defaultLabel', 'required'],
    data() {
      return {
        selectCount: 1,
        selectValues: {1: undefined}
      }
    },
    watch: {
      value: function () {
        if (this.value && this.value.length > 0) {
          this.selectCount = this.value.length;
          for (let i = 0; i < this.value.length; i++) {
            this.selectValues[i + 1] = this.value[i];
          }
        } else {
          this.selectCount = 1;
          this.selectValues = {1: undefined};
        }
      }
    },
    methods: {
      emit() {
        this.$emit('input', Object.values(this.selectValues).filter(value => value != null));
        this.$emit('change');
      },
      addSelect() {
        this.selectCount++;
      },
      removeSelect(index) {
        delete this.selectValues[index];
        this.emit();
        this.selectCount--;
      },
      isDisabled(val) {
        return Object.values(this.selectValues).findIndex(value => val === value) !== -1 || this.isSameGroupeWasadded(val);
      },
      isSameGroupeWasadded(val) {
        if (ROLES_GPEC.includes(val.role) && Object.values(this.selectValues).some(x => x && ROLES_GPEC.includes(x.role))) {
          return true;
        }
        if (ROLES_SECURITE.includes(val.role) && Object.values(this.selectValues).some(x => x && ROLES_SECURITE.includes(x.role))) {
          return true;
        }
        if (ROLES_EMPREINTE.includes(val.role) && Object.values(this.selectValues).some(x => x && ROLES_EMPREINTE.includes(x.role))) {
          return true;
        }
        if (ROLES_EFFECTIFS.includes(val.role) && Object.values(this.selectValues).some(x => x && ROLES_EFFECTIFS.includes(x.role))) {
          return true;
        }
        return false;
      }
    }
  };
</script>
